module.exports = __webpack_public_path__ + "static/media/giftsSent_100_250.759d91f1.png";